import _slicedToArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { SecondaryTileLabeledInputContext } from './secondary-tile.context.js';
import { createComponent } from '../core/create-component.js';
var SecondaryTileLabeledInput = createComponent({
  displayName: 'SecondaryTileLabeledInput',
  root: 'div',
  propConfig: {
    classNames: ['swan-secondary-tile-labeled-input'],
    derivedProps: function derivedProps() {
      var _React$useState = React.useState(),
          _React$useState2 = _slicedToArray(_React$useState, 2),
          labelId = _React$useState2[0],
          setLabelId = _React$useState2[1];

      return {
        labelId: labelId,
        setLabelId: setLabelId
      };
    },
    wrapRoot: function wrapRoot(_props, derivedProps, element) {
      var labelId = derivedProps.labelId,
          setLabelId = derivedProps.setLabelId;
      return /*#__PURE__*/React.createElement(SecondaryTileLabeledInputContext.Provider, {
        value: {
          labelId: labelId,
          setLabelId: setLabelId
        }
      }, element);
    }
  }
});
export { SecondaryTileLabeledInput };